import React from 'react';
import { Card, Flex, Grid, Skeleton } from 'antd';
// The page's own sheet: this skeleton is the route's Suspense fallback and
// RouteSkeleton's (initial bundle), so it paints before the page's chunk and
// draws with the page's classes (data-views-filter-section, -table-container…).
// Safe eagerly: its rules are scoped to data-views-* / the column menu's popup.
import '../DataViewsPlaceholder/DataViewsPlaceholder.css';
import { DataViewsLoadingSkeleton } from './DataViewsLoadingSkeleton';

const { useBreakpoint } = Grid;

/**
 * A Data View while its chunk loads, in the page's own frame: the margin, the
 * breadcrumb above the card, and inside it the same body the loaded page shows
 * while it fetches its table (title, toolbar, table) — one shape from refresh to data.
 */
export function DataViewsPageSkeleton(): React.ReactElement {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  return (
    <Flex
      vertical
      gap={0}
      aria-busy="true"
      style={{ margin: isMobile ? 'var(--ant-paddingSM)' : 'var(--ant-paddingLG)' }}
    >
      <div className="app-breadcrumb">
        <Skeleton.Input active size="small" style={{ width: 240, minWidth: 0, height: 22 }} />
      </div>
      <Card className="data-views-page-card" styles={{ body: { padding: 0 } }}>
        <DataViewsLoadingSkeleton />
      </Card>
    </Flex>
  );
}
